import { Box, Button, Checkbox, Modal, Stack, TextField, Tooltip, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { modalStyle } from '../../components/modalStyle';
import { TrainingPlan } from '@/generated';
import { useCreatePlan, useUpdatePlan } from '@/hooks/plan-mutation.hooks';

const createEmptyPlan = () => ({ units: [], id: '', title: '', unlockMode: false, allowUsersToRateWorkout: true, creatorId: '', viewerIds: [], editorIds: [] }) as TrainingPlan;

export const UpdatePlanModal = (props: { show: boolean; setShow: (show: boolean) => void; plan?: TrainingPlan }) => {
  const { plan, show, setShow } = props;
  const [editPlan, setEditPlan] = useState<TrainingPlan>(createEmptyPlan());
  const [informViewers, setInformViewers] = useState<boolean>(false);
  const createPlanMutation = useCreatePlan();
  const updatePlanMutation = useUpdatePlan();

  useEffect(() => {
    if (plan) setEditPlan(plan);
  }, [plan]);

  return (
    <Modal
      open={show}
      onClose={() => {
        setShow(false);
      }}
    >
      <Box sx={modalStyle}>
        <Typography variant="h4">{props.plan ? 'Update' : 'Create'} Plan</Typography>
        <Stack>
          {props.plan ? (
            <Stack sx={{ alignItems: 'center', mt: 2 }} direction={'row'}>
              <Checkbox value={informViewers} onChange={(v) => setInformViewers(!informViewers)} />{' '}
              <Tooltip title="Send an update email to all users who have this plan assigned.">
                <Typography>Send Update Email</Typography>
              </Tooltip>
            </Stack>
          ) : (
            <></>
          )}
          <TextField
            sx={{ my: 2 }}
            multiline
            label={'Name'}
            value={editPlan.title}
            onChange={(e) => {
              setEditPlan({ ...editPlan, title: e.currentTarget.value });
            }}
          />
          <TextField
            sx={{ my: 2 }}
            multiline
            minRows={3}
            label={'Description'}
            value={editPlan.description}
            onChange={(e) => {
              setEditPlan({ ...editPlan, description: e.currentTarget.value });
            }}
          />
          &nbsp;
          <Stack sx={{ alignItems: 'center' }} direction={'row'}>
            <Checkbox checked={editPlan.unlockMode} onChange={(c) => setEditPlan({ ...editPlan, unlockMode: !editPlan.unlockMode })} />
            <Tooltip title="When enabled, units and workouts in a plan must be completed in key order. A unit or workout becomes available only after the previous one is completed.">
              <Typography>Unlock Mode</Typography>
            </Tooltip>
          </Stack>
          <Stack sx={{ alignItems: 'center' }} direction={'row'}>
            <Checkbox checked={editPlan.allowUsersToRateWorkout} onChange={(c) => setEditPlan({ ...editPlan, allowUsersToRateWorkout: !editPlan.allowUsersToRateWorkout })} />
            <Tooltip title="Shows a “Rate This Workout” dialog in the app after completing a workout. Users can rate each workout based on effort, efficiency, and enjoyment using 0 to 5 stars.">
              <Typography>Enable Workout Ratings</Typography>
            </Tooltip>
          </Stack>
          <Button
            onClick={async () => {
              if (props.plan) await updatePlanMutation.mutateAsync({ notifyUsers: informViewers, plan: editPlan });
              else {
                await createPlanMutation.mutateAsync(editPlan);

                setEditPlan(createEmptyPlan());
              }
              setShow(false);
            }}
          >
            {props.plan ? 'Save' : 'Create'}
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};
